module.exports = __webpack_public_path__ + "static/media/Quiche-Flare-Bold.d8c90236.eot";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/Quiche-Flare-Bold.eot
// module id = 2281
// module chunks = 50